import { useTranslation } from 'react-i18next';

import { ControlledMaskedTextField, Fieldset } from '@components';
import { EditMode } from '@types';

export const DebtAmount = ({ editMode }: EditMode) => {
  const { t } = useTranslation('subModules/debtAmount');

  return (
    <Fieldset label={t('label')} data-tf-sensitive="true" required>
      <ControlledMaskedTextField
        maskType="currency"
        fieldName="debtAmount"
        data-testid="amountSubModule"
        label={editMode ? '' : t('amount')}
        helperText={editMode ? '' : t('helperText')}
        inputMode="numeric"
        placeholder="0"
        currencyIcon
        data-tf-sensitive="true"
      />
    </Fieldset>
  );
};
